import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ChartComponent } from '../../components/charts/chart.component';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { TableView, TableViewHelper } from '../../domain/tableview.domain';
import { AssetAllocation } from '../../domain/lti';

import {
  AssetAllocationPieChartService,
  PieValueField,
  TooltipValueField
} from './asset-allocation-pie-chart.service';

@Component({
  selector: 'td-wb-asset-allocation-pie-chart',
  template: '<td-wb-chart [options]="options" />',
  imports: [
    ChartComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetAllocationPieChartComponent implements OnChanges {

  @Input() assetAllocations: Array<AssetAllocation>;
  @Input() pieValueField: PieValueField;
  @Input() tooltipValueField?: TooltipValueField;
  @Input() tooltipValueFormat: string = 'n1';
  @Input() size: number;
  @Input() innerSize: number | string;
  @Input() animation: boolean = true;

  options: Highcharts.Options;

  private view: TableView;

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private mediaQueryService: MediaQueryService,
              private assetAllocationPieChartService: AssetAllocationPieChartService) {
    this.mediaQueryService.observe(Breakpoint.MD)
      .pipe(takeUntilDestroyed())
      .subscribe((breakpointState: BreakpointState): void => {
        this.view = TableViewHelper.fromBreakpoint(breakpointState);
        this.createChart(this.assetAllocations, true);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assetAllocations !== undefined && changes.assetAllocations.currentValue !== undefined) {
      this.createChart(changes.assetAllocations.currentValue, false);
    }
  }

  private createChart(assetAllocations: Array<AssetAllocation>,
                      markForCheck: boolean): void {
    if (this.view !== undefined && assetAllocations !== undefined) {
      this.options = this.assetAllocationPieChartService
        .createChartConfiguration(
          assetAllocations,
          this.pieValueField,
          this.tooltipValueField,
          this.tooltipValueFormat,
          this.getPieSize(),
          this.innerSize,
          this.animation);
      if (markForCheck === true) {
        this.changeDetectorRef.markForCheck();
      }
    }
  }

  private getPieSize(): number {
    if (this.size !== undefined) {
      return this.size;
    }
    return this.view === 'table_narrow' ? 200 : 140;
  }

}
